module.exports = __webpack_public_path__ + "static/media/veneto-3-05.b42699a1.jpg";